import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import {
  ClipboardText, MapPin, Image as ImageIcon, PencilSimple, Trash, Check,
} from '@phosphor-icons/react';

function getStatusBadge(status) {
  const map = {
    open: <span className="chantix-badge chantix-badge-warning">En cours</span>,
    closed: <span className="chantix-badge chantix-badge-success">Levee</span>,
    pending: <span className="chantix-badge chantix-badge-info">En attente</span>,
  };
  return map[status] || <span className="chantix-badge chantix-badge-neutral">{status || 'N/A'}</span>;
}

function getPriorityClass(priority) {
  const map = { high: 'priority-high', medium: 'priority-medium', low: 'priority-low' };
  return map[priority] || '';
}

export function RéserveCard({ réserve, chantierName, onEdit, onDelete, onUpdateStatus }) {
  return (
    <Card className={`chantix-card ${getPriorityClass(réserve.priority)}`}
      data-testid={`réserve-card-${réserve.id}`}>
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start gap-4 flex-1 min-w-0">
            <div className="p-3 rounded-lg bg-amber-100 flex-shrink-0">
              <ClipboardText size={24} className="text-amber-600" weight="fill" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1 flex-wrap">
                <h3 className="font-bold text-[#111827]">{réserve.title || 'Sans titre'}</h3>
                {getStatusBadge(réserve.status)}
              </div>
              <p className="text-sm text-[#4B5563] mb-2">{réserve.description || ''}</p>
              <div className="flex flex-wrap gap-3 text-sm text-[#4B5563]">
                <span className="flex items-center gap-1"><MapPin size={14} />{réserve.location || 'Non localisee'}</span>
                <span className="text-[#0055FF] font-medium">{chantierName}</span>
                {réserve.photos?.length > 0 && (
                  <span className="flex items-center gap-1"><ImageIcon size={14} />{réserve.photos.length} photo(s)</span>
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2 flex-shrink-0">
            <div className="flex gap-2">
              <Button variant="outline" size="icon" onClick={() => onEdit(réserve)}
                className="h-12 w-12" data-testid={`edit-réserve-${réserve.id}`}>
                <PencilSimple size={20} />
              </Button>
              <Button variant="outline" size="icon" onClick={() => onDelete(réserve)}
                className="h-12 w-12 text-red-600 hover:bg-red-50" data-testid={`delete-réserve-${réserve.id}`}>
                <Trash size={20} />
              </Button>
            </div>
            {réserve.status === 'open' && (
              <Button variant="outline" size="sm"
                onClick={() => onUpdateStatus(réserve.id, 'closed')}
                className="text-emerald-600 border-emerald-600 hover:bg-emerald-50 h-12"
                data-testid={`close-réserve-${réserve.id}`}>
                <Check size={16} className="mr-1" /> Lever
              </Button>
            )}
            {réserve.status === 'closed' && (
              <Button variant="outline" size="sm"
                onClick={() => onUpdateStatus(réserve.id, 'open')}
                className="text-amber-600 border-amber-600 hover:bg-amber-50 h-12"
                data-testid={`reopen-réserve-${réserve.id}`}>
                Reouvrir
              </Button>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
